import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const highlights = ['Printable PDFs', 'One-Time Payment', 'No Subscription', 'Adult A2–B1 Practice'];
export function Hero() {
  return <section className="w-full bg-stone-50 px-5 pb-20 pt-5" data-id="element-96" data-mp="9luyujz7c3so">
      <div className="mx-auto max-w-4xl text-center" data-id="element-97" data-mp="4lqf8l2zysy8">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-[2.6rem] font-black leading-[1.02] tracking-tight text-stone-900 sm:text-6xl md:text-[4.5rem]" data-id="element-98" data-mp="4na0yr7f9w7e">
          Solve a Full Year of Restaurant English in Just{' '}
          <span className="italic text-red-500" data-id="element-99" data-mp="nczrh245jvti">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-stone-600 sm:text-lg" data-id="element-100" data-mp="3d21sryrtemo9">
          36 ready-to-teach lessons for a full teaching year—one lesson a week.
          Spend five minutes reviewing the dialogue, worksheet and teacher key,
          then walk into class with your materials ready.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-101" data-mp="3e7uydrlt2vpx">
          <img src="https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832225633_main-mockup.webp" alt="Restaurant English Ready digital PDF bundle: six volumes, five bonuses, and previews on a computer, tablet and phone" width="1536" height="1024" fetchPriority="high" className="w-full h-auto object-contain mix-blend-multiply" data-id="element-102" data-mp="2ql6b0qe12b1x" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="-mt-2 sm:mt-8" data-id="element-103" data-mp="s3cloaja7jqk">
          <CtaButton href="#offer" data-id="element-104" data-mp="ddnh05bzcxlj" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-stone-500 sm:text-sm" data-id="element-105" data-mp="deq7ic5e4y0x">
            {highlights.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-106" data-mp="161jcj6ptcjgq" data-mpi={index}>
                <span data-id="element-107" data-mp="112pwp7n20gde">{item}</span>
                {index < highlights.length - 1 && <span aria-hidden="true" className="text-stone-300" data-id="element-108" data-mp="110wovp0pfq3t">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}